import { useSiteMetadata } from "../../hooks/useSiteMetadata"

export default function SiteMetadata() {
  return useSiteMetadata()
}
